// Klucz musi być identyczny z RICH_TEXT_LINT_STORAGE_KEY w core (TiptapEditor.vue)
const RICH_TEXT_LINT_STORAGE_KEY = 'ideo.tiptap.rich-text-lint.enabled';
const RICH_TEXT_LINT_MIGRATED_KEY = 'logito.tiptap.rich-text-lint.default-off';

export default defineNuxtPlugin({
    name: 'logito-rich-text-lint',
    setup()
    {
        // W Logito lint treści ma być domyślnie wyłączony. Samo zasianie brakującego
        // klucza nie wystarcza: core przy pierwszym montażu edytora zapisuje do
        // localStorage domyślne `true` (VueUse writeDefaults), więc istniejący
        // użytkownicy mają już `true` bez świadomej decyzji. Migracja wymusza `false`
        // jednorazowo — późniejsze ręczne włączenie lintu zostaje zachowane
        if (localStorage.getItem(RICH_TEXT_LINT_MIGRATED_KEY) === null)
        {
            localStorage.setItem(RICH_TEXT_LINT_STORAGE_KEY, 'false');
            localStorage.setItem(RICH_TEXT_LINT_MIGRATED_KEY, '1');
        }
    }
});
